exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-control[type=email][data-v-4251403f],.form-control[type=number][data-v-4251403f],.form-control[type=search][data-v-4251403f],.form-control[type=tel][data-v-4251403f],.form-control[type=text][data-v-4251403f],textarea.form-control[data-v-4251403f]{border-radius:5px;font-size:14px}.dropdown[data-v-4251403f]{display:inline-block}.form-control-label[data-v-4251403f]{margin-bottom:.5rem;padding:0}.header[data-v-4251403f],.set-buttons[data-v-4251403f]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}label[data-v-4251403f]{font-weight:500}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4251403f","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/franchise_component/order-layout/action/action-groups.vue
// module id = waCi
// module chunks = 86